import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HeaderComponent from "./components/HeaderComponent";
import HomePage from "./pages/Home/HomePage";
import FooterComponent from "./components/FooterComponent";
import TooltipComponent from "./components/Tooltip/TooltipComponent";
import NotFoundPage from "./pages/NotFound/NotFoundPage";
import ProductsPage from "./pages/Products/ProductsPage";
import { ThemeConst } from "./constants/ThemeConst";
import { ConfigProvider } from "antd";
import ScrollToTop from "./components/common/ScrollToTop";
import MessengerChatWidget from "./components/MessengerChat/MessengerChatWidget";
import CallButton from "./components/CallButton/CallButton";
import AboutUsPage from "./pages/AboutUs/AboutUsPage";
import ProductDetailPage from "./pages/ProductDetail/ProductDetail";
import AdminManagement from "./pages/AdminManagement/AdminManagement";
import { ToastContainer } from "react-toastify";
import ServicesOffersListPage from "./pages/ServicesOffers/ServicesOffersListPage";
import ServiceOfferDetailPage from "./pages/ServicesOffers/ServiceOfferDetailPage";
import ContactPage from "./pages/Contact/ContactPage";
// import LuckySpinMiniGame from "./pages/LuckySpinMiniGame/LuckySpinMiniGame";
// import MaintenancePage from "./pages/Maitenance/MaitenancePage";

// const isSiteLocked = () => {
//   const now = new Date();
//   const lockStart = new Date("2025-06-04T17:00:00Z");
//   const lockEnd = new Date("2026-06-04T17:00:00Z");

//   return now >= lockStart && now <= lockEnd;
// };

function App() {
  // if (isSiteLocked()) {
  //   return <MaintenancePage />;
  // }
  return (
    <ConfigProvider theme={ThemeConst}>
      <Router>
        <ScrollToTop />
        <HeaderComponent />
        <main
          className="mt-[5rem]"
          style={{ minHeight: "calc(100vh - 21.5rem)" }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/products/:productCategory"
              element={<ProductsPage />}
            />
            <Route path="/products" element={<ProductsPage />} />
            <Route
              path="/products/:productCategory/:productSlug"
              element={<ProductDetailPage />}
            />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route
              path="/services-offers"
              element={<ServicesOffersListPage />}
            />
            <Route
              path="/services-offers/:serviceSlug"
              element={<ServiceOfferDetailPage />}
            />
            <Route path="/admin/management" element={<AdminManagement />} />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        {/* <LuckySpinMiniGame /> */}
        <TooltipComponent />
        <FooterComponent />
        <CallButton />
        <MessengerChatWidget />
      </Router>
      <ToastContainer />
    </ConfigProvider>
  );
}

export default App;
